import { useState, useEffect } from "react";
import { useAuth } from "../contexto/AuthContext";
import axiosApi from "../servicios/axios.service";
import { impersonate } from "../servicios/auth.service";

import {
  Container,
  Typography,
  Button,
  Paper,
  CircularProgress,
  IconButton,
  Fab,
  TextField,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import KeyIcon from "@mui/icons-material/VpnKey"; // 🔑 Importa el icono de llave
import ModalNuevoCliente from "../componentes/ModalNuevoCliente";
const Dashboard = () => {
  const { user, logout } = useAuth();
  const [datos, setDatos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openModal, setOpenModal] = useState(false);
  const [busqueda, setBusqueda] = useState("");

  useEffect(() => {
    getDatos();
  }, []);
  const getDatos = async () => {
    try {
      const response = await axiosApi.get("/revendedor/clientes");
      console.log("🚀 ~ getDatos ~ response:", response);

      const datosTransformados = response.data.map((cliente) => ({
        ...cliente,
        // id: cliente.id,
        nombre_admin: cliente.primer_administrador?.name || "No asignado",
        id_admin: cliente.primer_administrador?.id || 0,
      }));

      setDatos(datosTransformados);
    } catch (error) {
      console.error("Error al obtener datos", error);
    } finally {
      setLoading(false);
    }
  };

  // Definir columnas del DataGrid
  const columns = [
    { field: "id", headerName: "ID", width: 70 },
    { field: "nombre", headerName: "Nombre", width: 250 },
    {
      field: "nombre_admin",
      headerName: "Admin",
      width: 200,
    },
    {
      field: "impersonate",
      headerName: "Acción",
      width: 100,
      sortable: false,
      renderCell: (params) => (
        <IconButton
          color="primary"
          onClick={() => handleImpersonate(params.row)}
        >
          <KeyIcon />
        </IconButton>
      ),
    },
    { field: "nombreFiscal", headerName: "Nombre Fiscal", width: 300 },
    { field: "cif", headerName: "CIF", width: 120 },
    { field: "localidad", headerName: "Localidad", width: 150 },
    { field: "provincia", headerName: "Provincia", width: 150 },
    { field: "telefono", headerName: "Teléfono", width: 150 },
    { field: "email", headerName: "Email", width: 250 },
    {
      field: "primer_administrador",
      headerName: "Admin",
      width: 200,

      renderCell: (params) => {
        console.log("🚀 ~ Dashboard ~ params:", params.row);
        return params.row?.primer_administrador?.name || "No asignado";
      },
    },
  ];
  const datosFiltrados = datos.filter((cliente) => {
    const texto = busqueda.trim().toLowerCase();
    if (!texto) return true;
    return [
      cliente.nombre,
      cliente.nombre_admin,
      cliente.nombreFiscal,
      cliente.cif,
      cliente.localidad,
      cliente.provincia,
      cliente.telefono,
      cliente.email,
    ]
      .filter(Boolean)
      .some((campo) => String(campo).toLowerCase().includes(texto));
  });

  // 📌 Función que se ejecuta al hacer clic en el icono de llave
  const handleImpersonate = async (row) => {
    try {
      console.log("🔑 Intentando impersonar usuario:", row);

      const userData = await impersonate(row.primer_administrador.id);

      console.log("🚀 Impersonación exitosa, datos recibidos:", userData);

      // 📌 Abrir `area-privada` en una nueva pestaña
      const nuevaVentana = window.open(
        "https://fichajedigital.com/area-privada",
        "_blank"
      );

      // const nuevaVentana = window.open(
      //   "http://localhost:3000/area-privada",
      //   "_blank"
      // );
      // 📌 Esperar a que la nueva ventana cargue y enviar `userData` completo
      setTimeout(() => {
        if (nuevaVentana) {
          nuevaVentana.postMessage({ userData }, "https://fichajedigital.com");
        }

        // if (nuevaVentana) {
        //   nuevaVentana.postMessage({ userData }, "http://localhost:3000");
        // }
      }, 3000);

      // 📌 Esperar a que la nueva ventana cargue y enviar `userData` completo
      // setTimeout(() => {
      //   if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
      //     // dev code
      //     console.log("desarrollo");
      //     const nuevaVentana = window.open(
      //       "http://localhost:3000/area-privada",
      //       "_blank"
      //     );
      //     if (nuevaVentana) {
      //       nuevaVentana.postMessage({ userData }, "http://localhost:3000");
      //     }
      //   } else {
      //     // production code
      //     console.log("produccion");
      //     const nuevaVentana = window.open(
      //       "https://fichajedigital.com/area-privada",
      //       "_blank"
      //     );
      //     if (nuevaVentana) {
      //       nuevaVentana.postMessage(
      //         { userData },
      //         "https://fichajedigital.com"
      //       );
      //     }
      //   }
      //   //   if (nuevaVentana) {
      //   //     nuevaVentana.postMessage({ userData }, "https://fichajedigital.com");
      //   //   }
      // }, 3000); // Espera 3 segundos para asegurar que la página ha cargado
    } catch (error) {
      console.error("❌ Error al suplantar usuario:", error);
    }
  };
  return (
    <Container maxWidth="lg" sx={{ mt: 4 }}>
      <Paper elevation={3} sx={{ p: 4, borderRadius: 2 }}>
        <Typography variant="h4" gutterBottom>
          Dashboard de Clientes
        </Typography>
        <Typography variant="subtitle1">Bienvenido, {user?.nombre}</Typography>

        <Button
          variant="contained"
          color="primary"
          sx={{ mt: 2, mb: 2 }}
          onClick={logout}
        >
          Cerrar sesión
        </Button>
        {/* Botón flotante */}
        <Fab
          color="primary"
          sx={{ position: "relative", ml: 12 }}
          onClick={() => setOpenModal(true)}
        >
          <AddIcon />
        </Fab>

        <TextField
          fullWidth
          variant="outlined"
          size="small"
          placeholder="Buscar cliente..."
          value={busqueda}
          onChange={(e) => setBusqueda(e.target.value)}
          sx={{ mt: 2 }}
          InputProps={{
            startAdornment: <SearchIcon sx={{ mr: 1, color: "action.active" }} />,
          }}
        />

        {loading ? (
          <CircularProgress />
        ) : (
          <DataGrid
            rows={datosFiltrados}
            columns={columns}
            pageSize={5}
            rowsPerPageOptions={[5, 10, 25]}
            autoHeight
            sx={{ mt: 2, height: 400 }}
          />
        )}
      </Paper>
      {/* Modal de agregar cliente */}
      <ModalNuevoCliente
        open={openModal}
        onClose={() => setOpenModal(false)}
        onClienteAgregado={getDatos}
      />
    </Container>
  );
};

export default Dashboard;
